import { ASSETS, Chapter, Reveal } from "../presentation";

export default function S08Ultima44() {
  return (
    <section id="ultima-44" className="about-immersive theme-dark" data-testid="slide-ultima-44">
      <div className="about-immersive-media" data-testid="ultima44-media">
        <img src={ASSETS.u44Sunset} alt="Sunreef Ultima 44 Z at sunset" />
      </div>
      <div className="u44z-scrim" />
      <div className="about-immersive-grain" />

      <div className="about-immersive-inner">
        <div className="sec-topbar" style={{ marginBottom: 0 }}>
          <Chapter ch="07" label="sunreef ultima 44" testid="ultima44-chapter" />
          <span className="wordmark wordmark-sm">SUNREEF</span>
        </div>

        <div className="about-immersive-content u44z-content">
          <Reveal><span className="eyebrow">.ultima range</span></Reveal>
          <Reveal delay={1}>
            <img
              className="model-logo model-logo-44r"
              src="/u44r-logo.png"
              alt="ULTIMA 44 R"
              data-testid="ultima44-logo"
            />
          </Reveal>

          <Reveal delay={2}>
            <h2 className="u44z-headline" data-testid="ultima44-headline">
              Fly farther.<br />
              <span className="lime">Feel more.</span>
            </h2>
          </Reveal>

          <Reveal className="bullet-list bullet-list-onimage" as="ul" delay={3} testid="ultima44-list">
            <li data-testid="ultima44-bullet-1">Performance Sunreef catamaran</li>
            <li data-testid="ultima44-bullet-2">Outboard propulsion options include 4× V8 500R</li>
            <li data-testid="ultima44-bullet-3">Foiling technology</li>
          </Reveal>
        </div>

        <div className="about-immersive-foot">
          <span className="about-caption about-caption-corner" aria-hidden="true"></span>
        </div>
      </div>
    </section>
  );
}
